module.exports = __webpack_public_path__ + "img/check.63208b21.svg";